import {parseCookies} from 'nookies';
import {useCallback, useEffect, useState} from 'react';
import {
  useDeleteFollowCompany,
  useUpdateFollowCompany,
} from '../../../core/repositories/companiesRepository';
import {useAuth} from '../../../core/usecases/useAuth';

type Props = {
  companyId: number;
  followCount: number;
  followed: boolean;
  open: () => void;
  setScoutPopup: (value: boolean) => void;
  scoutPopupShowDate: string;
};

export function useHandleFollowCompany({
  companyId,
  followCount,
  followed,
  open,
  setScoutPopup,
  scoutPopupShowDate,
}: Props) {
  const cookies = parseCookies();
  const {isSignedIn} = useAuth();
  const [followCountUpdated, setFollowCountUpdated] =
    useState<number>(followCount);
  const [isFollowed, setIsFollowed] = useState<boolean>(followed);

  const updateFollowCompany = useUpdateFollowCompany({
    onSuccessFunc() {
      const now = new Date();
      const showDate = new Date(scoutPopupShowDate);
      if (!(showDate.getTime() > now.setMonth(now.getMonth() - 3))) {
        setScoutPopup(true);
      }

      setIsFollowed(true);
      setFollowCountUpdated(followCountUpdated + 1); // フォロー数ランキング用にAPIのレスポンスを使わないようにする
    },
  });
  const deleteFollowCompany = useDeleteFollowCompany({
    onSuccessFunc() {
      setIsFollowed(false);
      setFollowCountUpdated(followCountUpdated - 1); // フォロー数ランキング用にAPIのレスポンスを使わないようにする
    },
  });

  useEffect(() => {
    setFollowCountUpdated(followCount);
    setIsFollowed(isFollowed);
  }, [companyId]);

  const unFollowCompanyUsecase = useCallback(
    async function unFollowCompanyUsecase() {
      if (!isSignedIn) {
        open();
        return;
      }

      deleteFollowCompany.mutate({companyId});
    },
    [companyId, cookies],
  );

  const updateFollowCompanyUsecase = useCallback(
    async function updateFollowCompanyUsecase() {
      if (!isSignedIn) {
        open();
        return;
      }

      updateFollowCompany.mutate({companyId});
    },
    [companyId, cookies],
  );

  const handleFollowCompany = useCallback(async () => {
    if (isFollowed) {
      await unFollowCompanyUsecase();
      return;
    }

    await updateFollowCompanyUsecase();
  }, [unFollowCompanyUsecase, isFollowed, updateFollowCompanyUsecase]);

  return {handleFollowCompany, followCountUpdated, isFollowed};
}
